import apiService from './ApiService';

export default class DocusignApiService {

    /**
     * Redirects to get Docusign Consent for admin user
     *
     * @return {Promise<ServiceResponse>}
     */
    async getDocusignConsent() {
        const request = await apiService.getData('/api/Docusign/consent').then(response => window.location.href = response.data.data);

        return request.data;
    }

    /**
     * Sets up the Docusign user with a temp code.
     * @param tempDocusignCode {ContactFormDTO}
     * @return {Promise<ServiceResponse>}
     */
    async setupDocusignUser(tempDocusignCode) {
        const request = await apiService.getData('/api/Docusign/setupDocusignUser?code=' + tempDocusignCode);

        return request.data;
    }

    /**
     * Get Docusign Account Templates
     *
     * @return {Promise<ServiceResponse>}
     */
    async getDocusignAccountTemplates() {
        const request = await apiService.getData('/api/Docusign/templates');

        return request.data;
    }

    async isConsented() {
        const request = await apiService.getData('/api/Docusign/currentConsent');

        return request.data;
    }
}
